import { render, staticRenderFns } from "./itemReleaseUndoList.vue?vue&type=template&id=ebef8860&scoped=true"
import script from "./itemReleaseUndoList.vue?vue&type=script&lang=js"
export * from "./itemReleaseUndoList.vue?vue&type=script&lang=js"
import style0 from "./itemReleaseUndoList.vue?vue&type=style&index=0&id=ebef8860&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebef8860",
  null
  
)

export default component.exports